import { useContext, useMemo } from 'react';
import { ThemeContext } from "../context/ThemeContext";

interface GlobalStyles {
	textRegular: React.CSSProperties;
	textBold: React.CSSProperties;
	textSemiBold: React.CSSProperties;
	textMedium: React.CSSProperties;
	montserratRegular: React.CSSProperties;
	montserratBoldItalic: React.CSSProperties;
	montserratMedium: React.CSSProperties;
	montserratBold: React.CSSProperties;
	montserratSemiBold: React.CSSProperties;
	courierRegular: React.CSSProperties;
	courierBoldItalic: React.CSSProperties;
	courierBold: React.CSSProperties;
	ibmPlexMonoRegular: React.CSSProperties;
	ibmPlexMonoMedium: React.CSSProperties;
	ibmPlexMonoItalic: React.CSSProperties;
	ibmPlexMonoBold: React.CSSProperties;
}

const useGlobalStyles = (): GlobalStyles => {
	const { theme } = useContext(ThemeContext);

	return useMemo(() => ({
		textRegular: {
		fontFamily: 'Pretendard-Regular',
		color: theme.text_01,
		},
		textBold: {
		fontFamily: 'Pretendard-Bold',
		color: theme.text_01,
		},
		textSemiBold: {
		fontFamily: 'Pretendard-SemiBold',
		color: theme.text_01,
		},
		textMedium: {
		fontFamily: 'Pretendard-Medium',
		color: theme.text_01,
		},
		montserratRegular: {
		fontFamily: 'Pretendard-Regular',
		color: theme.text_01,
		},
		montserratBoldItalic: {
		fontFamily: 'Pretendard-BoldItalic',
		color: theme.text_01,
		},
		montserratMedium: {
		fontFamily: 'Pretendard-Medium',
		color: theme.text_01,
		},
		montserratBold: {
		fontFamily: 'Pretendard-Bold',
		color: theme.text_01,
		},
		montserratSemiBold: {
		fontFamily: 'Pretendard-SemiBold',
		color: theme.text_01,
		},
		courierRegular: {
		fontFamily: 'Courier-Regular',
		color: theme.text_01,
		},
		courierBoldItalic: {
		fontFamily: 'Courier-BoldItalic',
		color: theme.text_01,
		},
		courierBold: {
		fontFamily: 'Courier-Bold',
		color: theme.text_01,
		},
		ibmPlexMonoRegular: {
		fontFamily: 'IBMPlexMono-Regular',
		color: theme.text_01,
		},
		ibmPlexMonoMedium: {
		fontFamily: 'IBMPlexMono-Medium',
		color: theme.text_01,
		},
		ibmPlexMonoItalic: {
		fontFamily: 'IBMPlexMono-Italic',
		color: theme.text_01,
		},
		ibmPlexMonoBold: {
		fontFamily: 'IBMPlexMono-Bold',
		color: theme.text_01,
		},
	}), [theme]);
};

export default useGlobalStyles;
